import { useEffect, useState, useSyncExternalStore, useCallback } from 'react';
import { subscribe, list, backendStatus, syncQueue, type QueuedWrite, pendingWrites } from './db';

/* Subscribe a component to the data layer. Re-renders on any write, local or synced. */
export function useList<T = any>(object: string): T[] {
  return useSyncExternalStore(
    subscribe,
    () => list<T>(object),
    () => list<T>(object),
  );
}

export function useBackend() {
  const [state, setState] = useState(backendStatus);
  useEffect(() => {
    const refresh = () => setState(backendStatus());
    const un = subscribe(refresh);
    window.addEventListener('online', refresh);
    window.addEventListener('offline', refresh);
    const t = setInterval(refresh, 15_000);
    return () => { un(); window.removeEventListener('online', refresh); window.removeEventListener('offline', refresh); clearInterval(t); };
  }, []);
  const sync = useCallback(() => { void syncQueue().then(() => setState(backendStatus())); }, []);
  return { ...state, sync };
}

export function usePending(): QueuedWrite[] {
  return useSyncExternalStore(subscribe, pendingWrites, pendingWrites);
}
